// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2614W","top":"styles_top__3hXcL","left":"styles_left__2fbvL","description":"styles_description__3l3HT"};